
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/elections/[year]/[raceUrlSlug]/[state]",
      function () {
        return require("private-next-pages/elections/[year]/[raceUrlSlug]/[state].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/elections/[year]/[raceUrlSlug]/[state]"])
      });
    }
  